export default "__VITE_ASSET__093c8ba2__"